// Material UI
import { makeStyles } from '@material-ui/core'
import { FontWeight } from './consts'

export default makeStyles(theme => ({
  root: ({ fontWeight }: { fontWeight: FontWeight }) => ({
    fontWeight,
  }),
}))
